'use strict';

var touchStyles = {
  WebkitTapHighlightColor: 'rgba(0,0,0,0)',
  WebkitTouchCallout: 'none',
  WebkitUserSelect: 'none',
  KhtmlUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  userSelect: 'none',
  cursor: 'pointer'
};

module.exports = touchStyles;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tappable/lib/touchStyles.js
 ** module id = 731
 ** module chunks = 0
 **/